export default __webpack_public_path__ + "static/BT_Benefits_Carousel_06-65915d796a063446a9950a26882575c3.jpg";